var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-App"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v1-Web-App---Request-Sent",
    transform: "translate(-253.000000, -355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send-email-1",
    transform: "translate(126.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M2.7,13.8c-0.8-0.2-1.4-1-1.4-1.9c0-0.9,0.5-1.7,1.4-1.9l26.8-8.7c0.4-0.1,0.7,0,1,0.2 s0.4,0.7,0.2,1l-8.7,26.8c-0.3,0.8-1.1,1.4-1.9,1.4s-1.6-0.6-1.9-1.4l-3-12.4L2.7,13.8z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path_1_",
    className: "st0",
    x1: 30.4,
    y1: 1.6,
    x2: 15.2,
    y2: 16.8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c505ecd1d89d55911da97cf3b925aee5.svg";
export { ForwardRef as ReactComponent };